/* Miss Polly - product page layer (03/10/2026).
 1) Sheets (size guide + "What's my size?").
 2) Size guide: tabs, CM | IN.
 3) "What's my size?": without account and brand step.
 4) Reel bubble + player (popup without controls, 1080p); video warmed in steps, zero bytes on load.
 Everything uses document-level delegation, so it survives the theme re-rendering the product section. */
(function () {
  'use strict';
  if (window.__misspollyPdp) return;
  window.__misspollyPdp = true;

  /* ---------------- 1) sheets ---------------- */
  var lastFocus = null;
  // Impact replaces every "liquid" block of the product form on each size change (theme.js onRerender_fn). The sheets
  // now live in their own section (sections/misspolly-pdp-sheets.liquid), but keep one copy only, as a guard: the
  // <body> copy holds the shopper's state.
  function sheet(id) {
    var all = document.querySelectorAll('[id="' + id + '"]'), keep = null, i;
    for (i = 0; i < all.length; i++) { if (all[i].parentNode === document.body) { keep = all[i]; break; } }
    if (!keep) return all[0] || null;
    for (i = 0; i < all.length; i++) { if (all[i] !== keep) all[i].remove(); }
    return keep;
  }
  function openSheet(id) {
    var s = sheet(id); if (!s) return;
    clearTimeout(s.__mpHide);
    if (s.parentNode !== document.body) document.body.appendChild(s); // escape transformed/overflow parents
    lastFocus = document.activeElement;
    s.hidden = false;
    requestAnimationFrame(function () { s.classList.add('is-open'); });
    setTimeout(function () { s.classList.add('is-open'); }, 30); // hidden tabs do not run rAF
    document.documentElement.classList.add('mp-lock');
    setTimeout(function () { var f = s.querySelector('button[data-mp-sheet-close]'); if (f) try { f.focus({ preventScroll: true }); } catch (e) {} }, 60);
  }
  function closeSheet(s) {
    if (!s) return;
    var sv = s.querySelector('video'); if (sv && !sv.paused) sv.pause();   // X, overlay AND Escape stop the reel
    if (s === rl.m) rl.resume = false;
    s.classList.remove('is-open');
    if (!document.querySelector('[data-mp-sheet].is-open')) document.documentElement.classList.remove('mp-lock');   // another sheet may still be open
    clearTimeout(s.__mpHide);
    s.__mpHide = setTimeout(function () { s.hidden = true; }, 260);   // cancelled if reopened within 260 ms
    if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch (e) {}
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { document.querySelectorAll('[data-mp-sheet].is-open').forEach(closeSheet); return; }
    if (e.key !== 'Tab') return;
    // keep keyboard focus inside an open sheet (aria-modal)
    var open = document.querySelector('[data-mp-sheet].is-open'); if (!open) return;
    var f = [].filter.call(open.querySelectorAll('a[href], button:not([disabled]), input:not([type=hidden]):not([disabled]), textarea, select'), function (el) { return el.getClientRects().length && !el.closest('[hidden]') && !el.closest('.mp-rvf__hp'); });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || !open.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !open.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  });

  // theme editor: when a section is re-rendered, drop the old copy of its sheets that was moved to <body>
  document.addEventListener('shopify:section:load', function (ev) {
    var t = ev.target; if (!t || !t.querySelectorAll) return;
    t.querySelectorAll('[data-mp-sheet][id]').forEach(function (n) {
      document.querySelectorAll('body > [id="' + n.id + '"]').forEach(function (old) { if (old !== n) old.remove(); });
    });
    if (!document.querySelector('[data-mp-sheet].is-open')) document.documentElement.classList.remove('mp-lock');
  });

  /* ---------------- 2) size guide ---------------- */
  function setUnit(sheet, u) {
    sheet.querySelectorAll('[data-mp-unit]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-mp-unit') === u ? 'true' : 'false'); });
    sheet.querySelectorAll('[data-cm]').forEach(function (el) { el.textContent = el.getAttribute(u === 'cm' ? 'data-cm' : 'data-in'); });   // chart cells, headers, model labels
    sheet.querySelectorAll('[data-mp-u]').forEach(function (el) { el.textContent = u === 'cm' ? '(CM)' : '(IN)'; });
  }
  function setTab(sheet, t) {
    sheet.querySelectorAll('[data-mp-tab]').forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-mp-tab') === t ? 'true' : 'false'); });
    sheet.querySelectorAll('[data-mp-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-mp-panel') !== t; });
  }

  /* ---------------- 3) what's my size ---------------- */
  var KEY = 'mp_fit_profile_v1';
  function loadProfile() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function saveProfile(p) { try { localStorage.setItem(KEY, JSON.stringify(p)); } catch (e) {} }

  // Body estimate from the size the shopper usually wears (inches). Generic values:
  // XS 32.1/24.8, S 34.6/26.8, M 36.7/28.85, L 38.7/30.9, XL 40.8/~33.5; US 2 32.9/25.8, US 6 35.2/28.3.
  // Hip = chest + 3.2 (with brand: XS 32.4/35.6, S 34.0/37.2, M 35.6/38.8).
  var LETTER = { XXS: [30.0, 22.8], XS: [32.1, 24.8], S: [34.6, 26.8], M: [36.7, 28.85], L: [38.7, 30.9], XL: [40.8, 33.2], XXL: [42.9, 35.4], '3XL': [45.0, 37.6], '4XL': [47.1, 39.8] };
  var US_NUM = { '00': [29.5, 22.3], '0': [31.2, 24.0], '2': [32.9, 25.8], '4': [34.0, 27.0], '6': [35.2, 28.3], '8': [37.4, 30.4], '10': [39.6, 32.4], '12': [41.8, 34.6], '14': [44.0, 36.8], '16': [46.2, 39.0], '18': [48.4, 41.2] };
  var REGION_SIZES = {
    us: ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '00', '0', '2', '4', '6', '8', '10', '12', '14', '16', '18'],
    uk: ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '4', '6', '8', '10', '12', '14', '16', '18', '20', '22'],
    au: ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '4', '6', '8', '10', '12', '14', '16', '18', '20', '22'],
    eu: ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '32', '34', '36', '38', '40', '42', '44', '46', '48']
  };
  function bodyFrom(region, size) {
    var cw = LETTER[size];
    if (!cw) {
      var n = parseInt(size, 10); if (isNaN(n) && size !== '00') return null;
      var us = size;
      if (region === 'uk' || region === 'au') us = String(n - 4);
      else if (region === 'eu') us = String(n - 32);
      if (us === '-4' || us === '-2') us = '00';
      cw = US_NUM[us];
    }
    if (!cw) return null;
    return { chest: cw[0], waist: cw[1], hip: cw[0] + 3.2 };
  }

  // Garment chart (inches) = midpoints of the Miss Polly size guide (cm / 2.54), index 0 = XXS.
  var CHART_CM = [[77, 58, 85], [82, 63, 90], [87, 68, 95], [92, 73, 100], [97, 78, 105], [102, 83, 110], [107, 88, 115], [112, 93, 120], [117, 98, 125], [122, 103, 130]];
  var LETTER_IDX = { XXS: 0, XS: 1, S: 2, M: 3, L: 4, XL: 5, XXL: 6, XXXL: 7, '3XL': 7, '4XL': 8 };
  var UK_IDX = { '4': 0, '6': 1, '8': 2, '10': 3, '12': 4, '14': 5, '16': 6, '18': 7, '20': 8, '22': 9 };
  function idxOf(label) {
    var l = String(label).toUpperCase().trim();
    if (LETTER_IDX[l] != null) return [LETTER_IDX[l]];
    if (UK_IDX[l] != null) return [UK_IDX[l]];
    var parts = l.split(/[\/-]/).filter(Boolean).map(function (p) { return LETTER_IDX[p] != null ? LETTER_IDX[p] : (UK_IDX[p] != null ? UK_IDX[p] : null); }).filter(function (x) { return x != null; });
    if (parts.length) return [Math.min.apply(null, parts), Math.max.apply(null, parts)];
    return null;
  }
  // a combined size (XS/S) is roomy up to the bigger size and snug down to the smaller one
  function garment(label) {
    var ix = idxOf(label); if (!ix) return null;
    var lo = CHART_CM[ix[0]], hi = CHART_CM[ix[ix.length - 1]];
    return { lo: { chest: lo[0] / 2.54, waist: lo[1] / 2.54, hip: lo[2] / 2.54 }, hi: { chest: hi[0] / 2.54, waist: hi[1] / 2.54, hip: hi[2] / 2.54 } };
  }
  function diff(g, body, area) {
    var lo = g.lo[area], hi = g.hi[area], b = body[area];
    if (b < lo) return lo - b;   // garment bigger than body -> loose (positive)
    if (b > hi) return hi - b;   // garment smaller -> tight (negative)
    return 0;
  }
  function word(d) {
    var a = Math.abs(d);
    if (a < 0.2) return 'True to Size';
    if (a <= 1.0) return d > 0 ? 'Slightly Loose' : 'Slightly Snug';
    return (d > 0 ? 'Loose - ' : 'Tight - ') + a.toFixed(1) + '"';
  }
  // stretch changes how much "tight" a dress can take (no stretch runs small)
  function tolerance(stretch) {
    var s = String(stretch || '').toLowerCase();
    if (s.indexOf('no') === 0) return 0.6;
    if (s.indexOf('high') === 0) return 1.8;
    if (s.indexOf('medium') === 0 || s.indexOf('moderate') === 0) return 1.4;
    return 1.0;
  }
  function analyse(root, profile) {
    var sizes = (root.getAttribute('data-sizes') || '').split('||').filter(Boolean);
    var body = bodyFrom(profile.region, profile.size); if (!body) return null;
    var tol = tolerance(root.getAttribute('data-stretch'));
    var rows = sizes.map(function (s) {
      var g = garment(s); if (!g) return null;
      var d = { chest: diff(g, body, 'chest'), hip: diff(g, body, 'hip'), waist: diff(g, body, 'waist') };
      return { size: s, d: d, min: Math.min(d.chest, d.hip, d.waist) };
    }).filter(Boolean);
    if (!rows.length) {
      // sizes the chart does not know (ONE SIZE, etc.): still recommend one, never leave the shopper without a size
      if (!sizes.length) return null;
      return { rows: sizes.map(function (s) { return { size: s, d: null, min: 0 }; }), rec: 0, plain: true };
    }
    var rec = null;
    for (var i = 0; i < rows.length; i++) { if (rows[i].min >= -tol) { rec = i; break; } }
    // owner, 04/10/2026: never "unavailable". Bigger than our biggest size -> the biggest; the smallest when smaller
    // (the loop above already returns 0 for a body smaller than every size).
    if (rec === null) rec = rows.length - 1;
    return { rows: rows, rec: rec };
  }

  function fitRoot() { return document.querySelector('[data-mp-fit]'); }
  function fitSheet() { return sheet('mp-fit-sheet'); }
  function show(step) {
    var sh = fitSheet(); if (!sh) return;
    sh.querySelectorAll('[data-mp-step]').forEach(function (s) { s.hidden = s.getAttribute('data-mp-step') !== String(step); });
    var body = sh.querySelector('.mp-sheet__body'); if (body) body.scrollTop = 0;
  }
  function fillSizes(sh, region, keep) {
    var sel = sh.querySelector('[data-mp-in="size"]'); if (!sel) return;
    var list = REGION_SIZES[region] || REGION_SIZES.us;
    sel.innerHTML = '<option value="">Select a size</option>' + list.map(function (s) { return '<option value="' + s + '">' + s + '</option>'; }).join('');
    if (keep && list.indexOf(keep) > -1) sel.value = keep;
  }
  function readStep1(sh) {
    var v = function (k) { var el = sh.querySelector('[data-mp-in="' + k + '"]'); return el ? parseFloat(el.value) : NaN; };
    var cmMode = sh.querySelector('[data-mp-hunit="cm"]').getAttribute('aria-pressed') === 'true';
    var kg = sh.querySelector('[data-mp-wunit="kg"]').getAttribute('aria-pressed') === 'true';
    var hcm = cmMode ? v('cm') : ((v('ft') || 0) * 12 + (v('in') || 0)) * 2.54;
    var w = v('w'); var wkg = kg ? w : w * 0.4536;
    return { hcm: hcm, wkg: wkg, age: v('age'), cmMode: cmMode, kg: kg, ok: hcm > 120 && hcm < 220 && wkg > 30 && wkg < 200 };
  }
  function validate(sh) {
    var s1 = readStep1(sh); sh.querySelector('[data-mp-next="1"]').disabled = !s1.ok;
    var size = sh.querySelector('[data-mp-in="size"]').value; sh.querySelector('[data-mp-next="2"]').disabled = !size;
  }
  function renderResult(pickIndex) {
    var sh = fitSheet(), root = fitRoot(), p = loadProfile(); if (!sh || !root || !p) return;
    var a = analyse(root, p);
    var title = sh.querySelector('[data-mp-res-title]'), sub = sh.querySelector('[data-mp-res-sub]'), areas = sh.querySelector('[data-mp-res-areas]'), pills = sh.querySelector('[data-mp-res-pills]');
    if (!a || a.rec === null) {
      title.textContent = 'We are sorry. Your best fitting size is unavailable.';
      sub.textContent = 'Please check the size guide or contact us and we will help you choose.';
      areas.innerHTML = ''; pills.innerHTML = ''; setLabel(null);
      var pk0 = sh.querySelector('[data-mp-fit-pick]'); if (pk0) pk0.hidden = true;
      return null;
    }
    var i = pickIndex == null ? a.rec : pickIndex, r = a.rows[i];
    if (i === a.rec) { title.textContent = 'We recommend a size ' + r.size; sub.textContent = 'We think that this size fits you the best.'; sub.hidden = false; }
    else { title.textContent = 'Fit analysis for Size ' + r.size; sub.hidden = true; }
    var pk = sh.querySelector('[data-mp-fit-pick]'); if (pk) { pk.hidden = false; pk.setAttribute('data-size', r.size); pk.textContent = 'Select size ' + r.size; }
    areas.innerHTML = r.d ? [['Chest', r.d.chest], ['Hip', r.d.hip], ['Waist', r.d.waist]].map(function (x) { return '<li><span>' + x[0] + '</span><strong>' + word(x[1]) + '</strong></li>'; }).join('') : '';
    var show = [a.rec]; if (a.rec > 0) show.push(a.rec - 1); if (a.rec < a.rows.length - 1) show.push(a.rec + 1);
    pills.innerHTML = show.map(function (k) {
      var on = k === i, isRec = k === a.rec;
      return '<button type="button" role="radio" aria-checked="' + on + '" class="mp-fit__pill' + (on ? ' is-on' : '') + (isRec ? ' is-rec' : '') + '" data-mp-pill="' + k + '" aria-label="Size ' + a.rows[k].size + (isRec ? ', Recommended' : '') + '">' + a.rows[k].size + (isRec ? '<span class="mp-fit__check" aria-hidden="true"><svg viewBox="0 0 16 16" width="12" height="12"><path d="M4 8.5l2.5 2.5L12 5.5" stroke="currentColor" stroke-width="1.8" fill="none"/></svg></span>' : '') + '</button>';
    }).join('');
    setLabel(a.rows[a.rec].size);
    return a.rows[a.rec].size;
  }
  /* 04/10/2026: the recommendation has to reach the cart. Selects the size in the theme's picker exactly like a tap on
     the size button (the theme re-renders the form and the URL gets ?variant=). Returns false if the size is not there. */
  function selectSize(size) {
    var want = String(size || '').trim().toUpperCase(); if (!want) return false;
    var sets = document.querySelectorAll('variant-picker fieldset');
    for (var i = 0; i < sets.length; i++) {
      var lg = sets[i].querySelector('legend'); if (!lg || !/size/i.test(lg.textContent)) continue;
      var inputs = sets[i].querySelectorAll('input[type="radio"]');
      for (var j = 0; j < inputs.length; j++) {
        // the radio value is the option-value ID (snippets/option-value.liquid); the size name is the label text
        var lb = inputs[j].id ? sets[i].querySelector('label[for="' + inputs[j].id + '"]') : null;
        var name = String(lb ? lb.textContent : inputs[j].value).trim().toUpperCase();
        if (name !== want) continue;
        if (inputs[j].checked) return true;
        (lb || inputs[j]).click();
        return true;
      }
    }
    return false;
  }
  function setLabel(size) {
    document.querySelectorAll('[data-mp-fit-label]').forEach(function (el) {
      el.innerHTML = size ? '<strong>Size: ' + size + '</strong> <span class="mp-fit__your">Your Recommendation</span>' : '<span class="mp-fit__ask">What\'s my size?</span>';
    });
  }
  function renderProfile() {
    var sh = fitSheet(), p = loadProfile(); if (!sh) return;
    var list = sh.querySelector('[data-mp-profile-list]'); if (!list) return;
    if (!p) { list.innerHTML = ''; return; }
    var ft = Math.floor(p.hcm / 2.54 / 12), inch = Math.round(p.hcm / 2.54 - ft * 12);
    if (inch === 12) { ft += 1; inch = 0; }
    var rows = [['Height', p.cmMode ? Math.round(p.hcm) + ' cm' : ft + ' ft ' + inch + ' in'], ['Weight', p.kg ? Math.round(p.wkg) + ' kg' : Math.round(p.wkg / 0.4536) + ' lb']];
    if (p.age) rows.push(['Age', p.age]);
    rows.push(['Usual size', String(p.region).toUpperCase() + ' ' + p.size]);
    list.innerHTML = rows.map(function (x) { return '<li><span>' + x[0] + '</span><strong>' + x[1] + '</strong></li>'; }).join('');
  }
  function prefill(sh, p) {
    if (!p) return;
    var set = function (k, val) { var el = sh.querySelector('[data-mp-in="' + k + '"]'); if (el && val != null && !isNaN(val)) el.value = val; };
    setHUnit(sh, p.cmMode ? 'cm' : 'ftin'); setWUnit(sh, p.kg ? 'kg' : 'lb');
    var tin = p.hcm / 2.54; set('ft', Math.floor(tin / 12)); set('in', Math.round(tin - Math.floor(tin / 12) * 12)); set('cm', Math.round(p.hcm));
    set('w', p.kg ? Math.round(p.wkg) : Math.round(p.wkg / 0.4536)); set('age', p.age);
    var reg = sh.querySelector('[data-mp-in="region"]'); reg.value = p.region || 'us'; fillSizes(sh, reg.value, p.size);
  }
  function setHUnit(sh, u) {
    sh.querySelectorAll('[data-mp-hunit]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-mp-hunit') === u ? 'true' : 'false'); });
    sh.querySelectorAll('[data-mp-units-group]').forEach(function (g) { g.hidden = g.getAttribute('data-mp-units-group') !== u; });
  }
  function setWUnit(sh, u) {
    sh.querySelectorAll('[data-mp-wunit]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-mp-wunit') === u ? 'true' : 'false'); });
    var l = sh.querySelector('[data-mp-wunit-label]'); if (l) l.textContent = u;
  }
  function openFit() {
    var sh = fitSheet(); if (!sh) return;
    var p = loadProfile();
    if (!sh.__ready) { sh.__ready = true; fillSizes(sh, 'us'); }
    openSheet('mp-fit-sheet');
    if (p) { renderResult(); show('result'); } else { show(1); }
    validate(sh);
  }

  /* ---------------- 4) reel player ----------------
 Look (04/10/2026, owner): popup. No browser controls.
 Desktop: black 80% backdrop, a 9:16 player (viewport height - 80 px, 15 px radius), white X at the top right of the
 screen. Phone: the player fills the whole screen; sound (left) and X (right) are 35 px dark circles at the top,
 never on top of each other. Bottom: white product cards (75x115 photo, name, price, chevron) that scroll sideways.
 Arrows (04/10/2026, owner: with one video they did nothing, so they show ONLY when the product has more than one):
 desktop < > at 15 px from the screen edges; phone up / down 30 px dark circles on the right. They loop.
 Swipe up / down on the video and the arrow keys also change the video. Each video shows only the cards of the products
 tagged in it (data-cards). Starts muted (autoplay is always allowed muted); the speaker
 button turns the sound on. A tap on the video pauses / resumes. Same player for review videos (section).
 Quality: the Liquid's largest mp4 (1080p) - the owner rejected 720p ("video sem qualidade").
 Weight:
 - page load: the bubble is a 64 px still. Zero video bytes, no <video> tag.
 - step 2, first scroll / touch / key with the main thread idle: the hidden player gets the mp4 with
 preload="metadata" (assigning src starts the load; no load call anywhere).
 - step 3, finger / mouse button down on a reel button: preload="auto", again without load.
 - click: play inside the gesture. Save-Data / 2G: steps 2 and 3 skipped, the click still plays.
 - pauses on close (X, backdrop, Escape) and while the tab is hidden; resumes when it comes back. */
  var rl = { m: null, v: null, url: '', lvl: '', resume: false, list: [], idx: 0, swipe: 0 };
  var ICO_CHEV = '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICO_MUTED = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M4 9v6h4l5 4V5L8 9H4z" fill="currentColor"/><path d="M16 9.5l5 5m0-5l-5 5" stroke="currentColor" stroke-width="1.8" fill="none"/></svg>';
  var ICO_SOUND = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M4 9v6h4l5 4V5L8 9H4z" fill="currentColor"/><path d="M16 8.5a5 5 0 0 1 0 7M18.5 6a8.5 8.5 0 0 1 0 12" stroke="currentColor" stroke-width="1.7" fill="none" stroke-linecap="round"/></svg>';

  function reelSlow() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    return !!(c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')));
  }
  function reelMp4(btn) { return btn.getAttribute('data-mp4') || btn.getAttribute('data-src') || ''; }

  function reelSoundIcon() {
    var b = rl.m && rl.m.querySelector('[data-mp-reel-sound]'); if (!b) return;
    var on = rl.v && !rl.v.muted;
    b.innerHTML = on ? ICO_SOUND : ICO_MUTED;
    b.setAttribute('aria-label', on ? 'Mute' : 'Unmute');
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
  }
  function reelStateIcon() {
    var s = rl.m && rl.m.querySelector('[data-mp-reel-state]'); if (!s) return;
    s.hidden = !(rl.v && rl.v.paused && rl.m && !rl.m.hidden && rl.v.readyState > 1);
  }
  function reelPlayer() {
    if (rl.v) return rl.v;
    var m = document.createElement('div');
    m.id = 'mp-reel-modal'; m.className = 'mp-reel-modal'; m.setAttribute('data-mp-sheet', ''); m.hidden = true;
    m.innerHTML = '<div class="mp-sheet__overlay" data-mp-sheet-close></div>' +
      '<button type="button" class="mp-reel-modal__x" data-mp-sheet-close aria-label="Close"><svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round"/></svg></button>' +
      '<button type="button" class="mp-reel-modal__nav mp-reel-modal__nav--prev" data-mp-reel-nav="-1" aria-label="Previous video">' + ICO_CHEV + '</button>' +
      '<button type="button" class="mp-reel-modal__nav mp-reel-modal__nav--next" data-mp-reel-nav="1" aria-label="Next video">' + ICO_CHEV + '</button>' +
      '<div class="mp-reel-modal__box" role="dialog" aria-modal="true" aria-label="Product video">' +
      '<video playsinline webkit-playsinline loop muted preload="none" disablepictureinpicture disableremoteplayback></video>' +
      '<button type="button" class="mp-reel-modal__tap" data-mp-reel-tap aria-label="Pause or play"></button>' +
      '<span class="mp-reel-modal__state" data-mp-reel-state hidden aria-hidden="true"><svg viewBox="0 0 24 24" width="30" height="30"><path d="M8 5v14l11-7z" fill="currentColor"/></svg></span>' +
      '<button type="button" class="mp-reel-modal__snd" data-mp-reel-sound aria-label="Unmute" aria-pressed="false">' + ICO_MUTED + '</button>' +
      '<div class="mp-reel-modal__cards" data-mp-reel-cards></div>' +
      '</div>';
    document.body.appendChild(m);
    var v = m.querySelector('video');
    v.muted = true; v.defaultMuted = true;       // by PROPERTY: the attribute alone is ignored once src comes from JS
    v.controls = false;
    ['volumechange', 'playing', 'pause', 'waiting', 'loadeddata'].forEach(function (n) {
      v.addEventListener(n, function () { reelSoundIcon(); reelStateIcon(); });
    });
    v.addEventListener('error', function () {        // a broken file must not leave a black box: retry once from scratch
      if (v.__mpRetried || !rl.url) return; v.__mpRetried = true;
      var u = rl.url; rl.url = ''; reelWarm({ getAttribute: function (k) { return k === 'data-mp4' ? u : null; } }, 'auto', true);
    });
    var tap = m.querySelector('[data-mp-reel-tap]'), sx = 0, sy = 0;   // swipe up = next video, down = previous
    tap.addEventListener('touchstart', function (e) { var p = e.touches[0]; sx = p.clientX; sy = p.clientY; }, { passive: true });
    tap.addEventListener('touchend', function (e) {
      var p = e.changedTouches[0], dx = p.clientX - sx, dy = p.clientY - sy;
      if (rl.list.length > 1 && Math.abs(dy) > 50 && Math.abs(dy) > Math.abs(dx)) { rl.swipe = Date.now(); reelGo(dy < 0 ? 1 : -1); }
    }, { passive: true });
    rl.m = m; rl.v = v;
    return v;
  }
  function reelAuto(btn) {                       // step 3: upgrade WITHOUT load(); the poster is only fetched here
    var v = rl.v; if (!v || !rl.url) return;
    var poster = btn.getAttribute && btn.getAttribute('data-poster');
    if (poster && v.getAttribute('poster') !== poster) v.poster = poster;
    if (rl.lvl !== 'auto') { rl.lvl = 'auto'; v.preload = 'auto'; }
  }
  // lvl 'meta' (step 2, hover, focus) or 'auto' (step 3).
  function reelWarm(btn, lvl, force) {
    if (!force && reelSlow()) return '';
    var url = reelMp4(btn); if (!url) return '';
    var v = reelPlayer();
    if (rl.url !== url) {
      rl.url = url; rl.lvl = 'meta';
      v.preload = 'metadata';
      v.src = url;                               // assigning src starts the load by itself: no load() here, ever
    }
    if (lvl === 'auto') reelAuto(btn);
    return url;
  }
  function reelCards(btn) {
    var box = rl.m.querySelector('[data-mp-reel-cards]');
    var wrap = btn.closest ? btn.closest('.mp-reel') : null;
    var tpl = wrap ? wrap.querySelector('template[data-mp-reel-cards]') : null;
    box.innerHTML = '';
    if (tpl && tpl.content) {
      var frag = tpl.content.cloneNode(true);
      var only = ((btn.getAttribute && btn.getAttribute('data-cards')) || '').split(',').filter(Boolean);
      if (only.length) {                         // only the products tagged in THIS video, in its order
        only.forEach(function (id) { var c = frag.querySelector('[data-pid="' + id + '"]'); if (c) box.appendChild(c); });
      } else box.appendChild(frag);
    }
    box.hidden = !box.children.length;
    box.scrollLeft = 0;
  }
  function reelPlay(v) {
    var p = v.play();
    if (p && p.catch) p.catch(function (err) {
      if (rl.m.hidden) return;
      if (err && err.name === 'NotAllowedError' && !v.muted) { v.muted = true; var q = v.play(); if (q && q.catch) q.catch(function () {}); return; }
      // AbortError (Safari / in-app browsers while the source settles): one retry on the first frame
      v.addEventListener('loadeddata', function () { if (!rl.m.hidden && v.paused) { var q2 = v.play(); if (q2 && q2.catch) q2.catch(function () {}); } }, { once: true });
    });
  }
  function reelOpen(btn) {
    var v = reelPlayer(), m = rl.m;
    clearTimeout(m.__mpHide);
    lastFocus = btn;
    var wrap = btn.closest ? btn.closest('.mp-reel') : null;   // the playlist = the bubbles of this product
    rl.list = wrap ? [].slice.call(wrap.querySelectorAll('[data-mp-reel]')) : [btn];
    rl.idx = Math.max(0, rl.list.indexOf(btn));
    if (rl.list.length > 1) m.setAttribute('data-multi', ''); else m.removeAttribute('data-multi');
    reelCards(btn);
    reelWarm(btn, 'auto', true);                 // same file already warmed: nothing is reloaded
    m.hidden = false;
    requestAnimationFrame(function () { m.classList.add('is-open'); });
    setTimeout(function () { m.classList.add('is-open'); }, 30);   // hidden tabs do not run rAF
    document.documentElement.classList.add('mp-lock');
    var x = m.querySelector('.mp-reel-modal__x'); if (x) try { x.focus({ preventScroll: true }); } catch (e) {}
    v.muted = true;                              // Starts muted; the speaker button turns the sound on
    reelPlay(v);
    reelSoundIcon(); reelStateIcon();
  }
  function reelSound() {
    var v = rl.v; if (!v) return;
    v.muted = !v.muted; if (!v.muted) v.volume = 1;
    if (v.paused) reelPlay(v);
    reelSoundIcon();
  }
  // previous / next video of the same product (loops). Keeps the sound as the person left it; one video loads at a time.
  function reelGo(d) {
    var n = rl.list.length, v = rl.v; if (n < 2 || !v) return;
    rl.idx = (rl.idx + d + n) % n;
    var btn = rl.list[rl.idx];
    lastFocus = btn;
    reelCards(btn);
    v.__mpRetried = false;
    reelWarm(btn, 'auto', true);
    reelPlay(v);
    reelSoundIcon(); reelStateIcon();
  }
  function reelTap() {
    var v = rl.v; if (!v) return;
    if (rl.swipe && Date.now() - rl.swipe < 500) return;   // the end of a swipe is not a tap
    if (v.paused) reelPlay(v); else v.pause();
    setTimeout(reelStateIcon, 30);
  }
  function reelIntent(e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-mp-reel]') : null; if (!b) return;
    reelWarm(b, (e.type === 'touchstart' || e.type === 'pointerdown') ? 'auto' : 'meta');
  }
  // step 2 starts on the first sign of a person using the page, never on the page load itself.
  (function reelStep2() {
    var evs = ['scroll', 'wheel', 'touchstart', 'keydown'], done = false;
    function go() {
      if (done) return; done = true;
      evs.forEach(function (n) { window.removeEventListener(n, go, true); });
      var b = document.querySelector('[data-mp-reel]'); if (!b || reelSlow()) return;
      var run = function () { reelWarm(b, 'meta'); };
      if (window.requestIdleCallback) requestIdleCallback(run, { timeout: 1200 }); else setTimeout(run, 300);
    }
    if (!document.querySelector('[data-mp-reel]')) return;   // no video on this page: listen to nothing
    evs.forEach(function (n) { window.addEventListener(n, go, { capture: true, passive: true }); });
  })();
  document.addEventListener('pointerover', reelIntent, { passive: true });   // pointerenter does not bubble; pointerover does
  document.addEventListener('focusin', reelIntent);
  document.addEventListener('touchstart', reelIntent, { passive: true });
  document.addEventListener('pointerdown', reelIntent, { passive: true });
  document.addEventListener('keydown', function (e) {
    if (!rl.m || !rl.m.classList.contains('is-open') || rl.list.length < 2) return;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); reelGo(1); }
    else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); reelGo(-1); }
  });
  document.addEventListener('visibilitychange', function () {
    var v = rl.v; if (!v) return;
    if (document.hidden) { if (!v.paused) { rl.resume = true; v.pause(); } return; }
    if (rl.resume && !rl.m.hidden) { rl.resume = false; reelPlay(v); }
  });

  /* ---------------- 5) reviews: stars under the title -> reviews section; "Write A Review" ----------------
 a tap on the stars under the title scrolls smoothly down to the reviews; the sticky header must not cover
 the heading. The review form (Shopify contact form) reopens after sending (thank-you / errors) and from a link to
 the product with #write-review (post-delivery e-mail). */
  // The rows above the reviews ("Customers also bought / viewed") can still be loading and change height during the
  // scroll; for 2.5 s the jump re-aims whenever the target drifts, and stops as soon as the shopper scrolls by hand.
  function rvHead() {
    var hdr = document.querySelector('.shopify-section--header'), head = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
    if (hdr && getComputedStyle(hdr).position !== 'sticky' && getComputedStyle(hdr).position !== 'fixed') head = 0;
    return head + 10;
  }
  function rvJump() {
    var target = document.getElementById('mp-reviews'); if (!target) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var aim = function (smooth) { window.scrollTo({ top: Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - rvHead()), behavior: smooth && !reduce ? 'smooth' : 'auto' }); };
    aim(true);
    try { history.replaceState(null, '', '#mp-reviews'); } catch (er) {}
    var stop = false, t0 = Date.now(), last = -1;
    var quit = function () { stop = true; };
    window.addEventListener('wheel', quit, { once: true, passive: true });
    window.addEventListener('touchstart', quit, { once: true, passive: true });
    (function watch() {
      if (stop || Date.now() - t0 > 2500) { if (!stop) try { target.focus({ preventScroll: true }); } catch (er) {} return; }
      var y = window.pageYOffset, off = target.getBoundingClientRect().top - rvHead();
      if (y === last && Math.abs(off) > 4) aim(false);     // scroll has settled but the target moved: correct it
      last = y;
      setTimeout(watch, 120);
    })();
  }
  // "Write A Review" form: photos picked here (several at once, up to 5), shrunk to 1600 px JPEG on the phone,
  // sent with the rest to the reviews service (form action). E-mail is required; opt-in only when ticked.
  var RVF_MAX = 5;
  function rvfFiles(f) { return f.__mpFiles || (f.__mpFiles = []); }
  function rvfThumbs(f) {
    var box = f.querySelector('[data-mp-rvf-thumbs]'), add = f.querySelector('[data-mp-rvf-add]'); if (!box) return;
    box.innerHTML = '';
    rvfFiles(f).forEach(function (file, i) {
      var d = document.createElement('div'); d.className = 'mp-rvf__thumb';
      var img = document.createElement('img'); img.alt = ''; img.src = URL.createObjectURL(file); img.onload = function () { URL.revokeObjectURL(img.src); };
      var x = document.createElement('button'); x.type = 'button'; x.className = 'mp-rvf__rm'; x.setAttribute('data-mp-rvf-rm', String(i)); x.setAttribute('aria-label', 'Remove photo ' + (i + 1)); x.textContent = '×';
      d.appendChild(img); d.appendChild(x); box.appendChild(d);
    });
    if (add) add.hidden = rvfFiles(f).length >= RVF_MAX;
  }
  function rvfShrink(file) {
    return new Promise(function (resolve) {
      if (file.type.indexOf('image/') !== 0 || !window.createImageBitmap) return resolve(file);
      createImageBitmap(file).then(function (bmp) {
        var max = 1600, sc = Math.min(1, max / Math.max(bmp.width, bmp.height));
        var c = document.createElement('canvas'); c.width = Math.round(bmp.width * sc); c.height = Math.round(bmp.height * sc);
        c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
        c.toBlob(function (b) { resolve(b ? new File([b], (file.name || 'photo').replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' }) : file); }, 'image/jpeg', 0.82);
      }).catch(function () { resolve(file); });   // HEIC etc. the browser cannot decode: send as is (server checks type)
    });
  }
  // review photos, big: one overlay for the whole page; counter "1 / 3", X, arrows (desktop and, since 05/10/2026, phone too),
  // sideways swipe (phone), Esc / arrow keys
  var rvg = { el: null, imgs: [], i: 0, back: null, x0: null, y0: 0 };
  function rvGalUrl(base, w) { return base + (base.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function rvGalShow() {
    var g = rvg.el, n = rvg.imgs.length, img = g.querySelector('.mp-rvg__img');
    img.src = rvGalUrl(rvg.imgs[rvg.i], 1200);
    img.srcset = [800, 1200, 1600].map(function (w) { return rvGalUrl(rvg.imgs[rvg.i], w) + ' ' + w + 'w'; }).join(', ');
    g.querySelector('.mp-rvg__n').textContent = n > 1 ? (rvg.i + 1) + ' / ' + n : '';
    g.querySelectorAll('[data-mp-rvg-nav]').forEach(function (b) { b.hidden = n < 2; });
    if (n > 1) { var nb = rvg.imgs[(rvg.i + 1) % n], nx = new Image(); nx.sizes = '92vw'; nx.srcset = [800, 1200, 1600].map(function (w) { return rvGalUrl(nb, w) + ' ' + w + 'w'; }).join(', '); nx.src = rvGalUrl(nb, 1200); }   // next one ready before the swipe, in the same width the viewer will ask for
  }
  function rvGalOpen(btn) {
    rvg.imgs = (btn.getAttribute('data-imgs') || '').split('|').filter(Boolean); if (!rvg.imgs.length) return;
    rvg.i = 0; rvg.back = btn;
    if (!rvg.el) {
      var g = document.createElement('div'); g.className = 'mp-rvg'; g.hidden = true; g.setAttribute('role', 'dialog'); g.setAttribute('aria-modal', 'true'); g.setAttribute('aria-label', 'Review photos');
      g.innerHTML = '<span class="mp-rvg__n" aria-live="polite"></span>' +
        '<button type="button" class="mp-rvg__x" data-mp-rvg-x aria-label="Close"><svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19" stroke="currentColor" stroke-width="1.6" fill="none"/></svg></button>' +
        '<button type="button" class="mp-rvg__nav mp-rvg__nav--p" data-mp-rvg-nav="-1" aria-label="Previous photo"><svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M15 5l-7 7 7 7" stroke="currentColor" stroke-width="1.6" fill="none"/></svg></button>' +
        '<img class="mp-rvg__img" alt="Customer photo" sizes="92vw" decoding="async">' +
        '<button type="button" class="mp-rvg__nav mp-rvg__nav--n" data-mp-rvg-nav="1" aria-label="Next photo"><svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="1.6" fill="none"/></svg></button>';
      g.addEventListener('touchstart', function (ev) {
        var t = ev.touches[0]; rvg.x0 = ev.touches.length === 1 ? t.clientX : null; rvg.y0 = t.clientY;   // two fingers = zoom, not a swipe
      }, { passive: true });
      // one finger never moves the page behind the photo (the iPhone scrolls it even with the page locked); two fingers still zoom
      g.addEventListener('touchmove', function (ev) { if (ev.touches.length === 1 && ev.cancelable) ev.preventDefault(); }, { passive: false });
      g.addEventListener('touchend', function (ev) {
        if (rvg.x0 == null) return; var t = ev.changedTouches[0], dx = t.clientX - rvg.x0, dy = t.clientY - rvg.y0; rvg.x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) rvGalGo(dx < 0 ? 1 : -1);   // sideways only: an up/down drag changes nothing
      });
      document.body.appendChild(g); rvg.el = g;
    }
    rvGalShow();
    rvg.el.hidden = false;
    document.documentElement.classList.add('mp-lock');
    try { rvg.el.querySelector('.mp-rvg__x').focus({ preventScroll: true }); } catch (er) {}
  }
  function rvGalGo(d) { var n = rvg.imgs.length; if (n < 2) return; rvg.i = (rvg.i + d + n) % n; rvGalShow(); }
  function rvGalClose() {
    if (!rvg.el || rvg.el.hidden) return;
    rvg.el.hidden = true; document.documentElement.classList.remove('mp-lock');
    if (rvg.back) try { rvg.back.focus({ preventScroll: true }); } catch (er) {}
  }
  document.addEventListener('keydown', function (ev) {
    if (!rvg.el || rvg.el.hidden) return;
    if (ev.key === 'Escape') rvGalClose(); else if (ev.key === 'ArrowRight') rvGalGo(1); else if (ev.key === 'ArrowLeft') rvGalGo(-1);
  });
  function rvThanks(name) {
    var t = sheet('mp-rv-thanks'); if (!t) return;
    var h = t.querySelector('[data-mp-rvt-title]');
    if (h) h.textContent = (h.getAttribute('data-tpl') || 'Thanks, [name]!').replace('[name]', name).replace(/,\s*!/, '!');   // no name: "Thanks!"
    openSheet('mp-rv-thanks');
  }
  function rvfErr(f, msg) { var e = f.querySelector('[data-mp-rvf-err]'); if (!e) return; e.textContent = msg || ''; e.hidden = !msg; }
  document.addEventListener('change', function (e) {
    var inp = e.target; if (!inp || !inp.matches || !inp.matches('[data-mp-rvf-file]')) return;
    var f = inp.closest('form'), list = rvfFiles(f), picked = [].slice.call(inp.files || []);
    var room = RVF_MAX - list.length;
    if (picked.length > room) rvfErr(f, 'You can add up to ' + RVF_MAX + ' photos.'); else rvfErr(f, '');
    picked.slice(0, Math.max(0, room)).forEach(function (p) { if (p.type.indexOf('image/') === 0 || /\.(heic|heif)$/i.test(p.name)) list.push(p); });
    inp.value = '';
    rvfThumbs(f);
  });
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.matches || !f.matches('[data-mp-rvf]')) return;
    e.preventDefault();
    if (f.__mpBusy) return;
    if (f.reportValidity && !f.reportValidity()) return;
    var btn = f.querySelector('[data-mp-rvf-submit]'), label = btn ? btn.textContent : '';
    f.__mpBusy = true; rvfErr(f, ''); if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
    Promise.all(rvfFiles(f).map(rvfShrink)).then(function (photos) {
      var fd = new FormData(f); fd.delete('photos');
      photos.forEach(function (p) { fd.append('photos', p, p.name || 'photo.jpg'); });
      return fetch(f.getAttribute('action'), { method: 'POST', body: fd });
    }).then(function (r) { return r.json().catch(function () { return { ok: false }; }).then(function (j) { return { r: r, j: j }; }); })
      .then(function (x) {
        if (x.j && x.j.ok) {
          // the form gives way to the "Thanks, <name>!" window; the form is left clean for a next review
          var who = (f.elements.name && f.elements.name.value || '').replace(/\s+/g, ' ').trim();
          closeSheet(f.closest('[data-mp-sheet]'));
          f.reset(); rvfFiles(f).length = 0; rvfThumbs(f);
          rvThanks(who);
          return;
        }
        var m = x.r.status === 429 ? 'Too many reviews from this connection. Please try again later.' :
          (x.j && x.j.fields ? 'Please check: ' + x.j.fields.join(', ') + '.' :
            (x.j && /foto/.test(x.j.error || '') ? 'One of the photos could not be used. Please remove it or use a JPG or PNG photo up to 8 MB.' : 'Sorry, your review could not be sent. Please try again.'));
        rvfErr(f, m);
      })
      .catch(function () { rvfErr(f, 'Connection problem. Please try again.'); })
      .then(function () { f.__mpBusy = false; if (btn) { btn.disabled = false; btn.textContent = label; } });
  });
  (function rvOnLoad() {
    var h = location.hash;
    if (h === '#write-review') {
      // the sheet CSS is loaded without blocking the page: open only once it is there
      var go = function () {
        var l = document.querySelector('link[href*="misspolly-pdp-sheets"]');
        if (l && l.media && l.media !== 'all' && !l.sheet) { l.addEventListener('load', function () { openSheet('mp-rv-write'); }, { once: true }); return; }
        openSheet('mp-rv-write');
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
    } else if (h === '#mp-reviews') {
      window.addEventListener('load', function () { setTimeout(rvJump, 50); });
    }
  })();

  /* ---------------- events ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var sgOpen = t.closest('[data-mp-sg-open]');
    if (sgOpen) {
      e.preventDefault();
      var sgs = sheet('mp-size-guide');   // always reopens on CLOTHING SIZE, in inches, at the top
      if (sgs) {
        setTab(sgs, 'size'); setUnit(sgs, 'in'); var sc = sgs.querySelector('.mp-hm__scroll'); if (sc) sc.scrollTop = 0;
        // the MODEL photo sits in a hidden tab: start its download now, so it is there when the tab is tapped
        var mi = sgs.querySelector('img.mp-hm__cardimg[loading="lazy"]'); if (mi) mi.loading = 'eager';
      }
      openSheet('mp-size-guide'); return;
    }
    var so = t.closest('[data-mp-sheet-open]'); if (so) { e.preventDefault(); openSheet(so.getAttribute('data-mp-sheet-open')); return; }
    var jump = t.closest('[data-mp-rv-jump]'); if (jump) { e.preventDefault(); rvJump(); return; }
    var rm = t.closest('[data-mp-rvf-rm]'); if (rm) { var rf = rm.closest('form'); rvfFiles(rf).splice(parseInt(rm.getAttribute('data-mp-rvf-rm'), 10), 1); rvfErr(rf, ''); rvfThumbs(rf); return; }
    var gal = t.closest('[data-mp-rv-gal]'); if (gal) { e.preventDefault(); rvGalOpen(gal); return; }
    if (t.closest('[data-mp-rvg-x]') || t.matches('.mp-rvg')) { rvGalClose(); return; }
    var nav = t.closest('[data-mp-rvg-nav]'); if (nav) { rvGalGo(parseInt(nav.getAttribute('data-mp-rvg-nav'), 10)); return; }
    var close = t.closest('[data-mp-sheet-close]');
    if (close) { closeSheet(close.closest('[data-mp-sheet]')); return; }
    var rn = t.closest('[data-mp-reel-nav]'); if (rn) { reelGo(parseInt(rn.getAttribute('data-mp-reel-nav'), 10)); return; }
    if (t.closest('[data-mp-reel-sound]')) { reelSound(); return; }
    if (t.closest('[data-mp-reel-tap]')) { reelTap(); return; }
    var rc = t.closest('.mp-reel-card[data-current]'); if (rc) { e.preventDefault(); closeSheet(rc.closest('[data-mp-sheet]')); return; }   // the card of the product already on screen just closes the player
    var u = t.closest('[data-mp-unit]'); if (u) { setUnit(u.closest('[data-mp-sheet]'), u.getAttribute('data-mp-unit')); return; }
    var tab = t.closest('[data-mp-tab]'); if (tab) { setTab(tab.closest('[data-mp-sheet]'), tab.getAttribute('data-mp-tab')); return; }
    var meas = t.closest('[data-mp-sg-measure]'); if (meas) { e.preventDefault(); var box = document.getElementById('mp-sg-measure'); if (box) box.scrollIntoView({ block: 'start' }); return; }   // instant jump
    if (t.closest('[data-mp-fit-open]')) { e.preventDefault(); openFit(); return; }
    var sh = fitSheet();
    var hu = t.closest('[data-mp-hunit]'); if (hu && sh) { setHUnit(sh, hu.getAttribute('data-mp-hunit')); validate(sh); return; }
    var wu = t.closest('[data-mp-wunit]'); if (wu && sh) { setWUnit(sh, wu.getAttribute('data-mp-wunit')); validate(sh); return; }
    var go = t.closest('[data-mp-fit-go]');
    if (go && sh) {
      var to = go.getAttribute('data-mp-fit-go');
      if (to === 'profile') { if (!loadProfile()) { show(1); return; } renderProfile(); show('profile'); return; }
      if (to === 'result') { if (!loadProfile()) { show(1); return; } renderResult(); show('result'); return; }
      if (to === '1') { prefill(sh, loadProfile()); validate(sh); show(1); return; }
    }
    if (t.closest('[data-mp-fit-delete]') && sh) {
      try { localStorage.removeItem(KEY); } catch (er) {}
      sh.querySelectorAll('input').forEach(function (i) { i.value = ''; });
      fillSizes(sh, 'us'); setLabel(null); validate(sh); show(1); return;
    }
    var pk = t.closest('[data-mp-fit-pick]'); if (pk) { selectSize(pk.getAttribute('data-size')); closeSheet(pk.closest('[data-mp-sheet]')); return; }
    var pill = t.closest('[data-mp-pill]'); if (pill) { renderResult(parseInt(pill.getAttribute('data-mp-pill'), 10)); return; }
    var rb = t.closest('[data-mp-reel]'); if (rb) { e.preventDefault(); reelOpen(rb); return; }
  });
  document.addEventListener('input', function (e) { var sh = fitSheet(); if (sh && sh.contains(e.target)) validate(sh); });
  document.addEventListener('change', function (e) {
    var sh = fitSheet(); if (!sh || !sh.contains(e.target)) return;
    if (e.target.matches('[data-mp-in="region"]')) fillSizes(sh, e.target.value);
    validate(sh);
  });
  document.addEventListener('submit', function (e) {
    var f = e.target, sh = fitSheet(); if (!sh || !sh.contains(f)) return;
    e.preventDefault();
    var step = f.getAttribute('data-mp-step');
    if (step === '1') { if (!readStep1(sh).ok) return; var p0 = loadProfile(); fillSizes(sh, sh.querySelector('[data-mp-in="region"]').value, p0 && p0.size); validate(sh); show(2); return; }
    if (step === '2') {
      var s1 = readStep1(sh), size = sh.querySelector('[data-mp-in="size"]').value; if (!s1.ok || !size) return;
      saveProfile({ hcm: s1.hcm, wkg: s1.wkg, age: isNaN(s1.age) ? null : s1.age, cmMode: s1.cmMode, kg: s1.kg, region: sh.querySelector('[data-mp-in="region"]').value, size: size });
      var rec = renderResult(); show('result');
      if (rec) selectSize(rec);                    // the label above the button and the cart now agree
    }
  });

  /* Impact replaces the liquid blocks on every size change, which closed the accordion the shopper had opened.
     Save the open state when the variant input changes (fires before the re-render) and restore it after. */
  var accState = null;
  document.addEventListener('change', function (e) {
    var t = e.target; if (!t || !t.form || !t.closest || !t.closest('variant-picker, .product-info')) return;
    accState = [].map.call(document.querySelectorAll('.product-info details.mp-acc__item'), function (d) { return d.open; });
  }, true);
  document.addEventListener('variant:change', function () {
    if (!accState) return;
    var keep = accState; accState = null;
    var list = document.querySelectorAll('.product-info details.mp-acc__item');
    if (list.length === keep.length) for (var i = 0; i < list.length; i++) list[i].open = keep[i];
  });

  // returning shopper: show "Size: X Your Recommendation" straight away
  function boot() { if (loadProfile() && fitRoot()) { var a = analyse(fitRoot(), loadProfile()); setLabel(a && a.rec !== null ? a.rows[a.rec].size : null); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('variant:change', function () { setTimeout(boot, 60); });
})();
